// userSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Rentals, AddRentalState } from "../../types";

const initialState: AddRentalState = {
  Rental: [],
  cancelRental: {
    id: "",
    reason: "",
  },
};

const addRentalSlice = createSlice({
  name: "addRental",
  initialState,
  reducers: {
    setRental: (state, action: PayloadAction<Partial<Rentals>>) => {
      // Update individual properties of the first object
      state.Rental[0] = {
        ...state.Rental[0],
        ...action.payload,
      };
    },
    clearRental: (state) => {
      state.Rental = [];
    },
    setCancelRental: (
      state,
      action: PayloadAction<Partial<{ id: string; reason: string }>>
    ) => {
      state.cancelRental = {
        ...state.cancelRental,
        ...action.payload,
      };
    },
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
  },
});

export const { setRental, clearRental, setCancelRental } =
  addRentalSlice.actions;
export default addRentalSlice.reducer;
